const getters = {
    supplier(state) {
      return state.supplier || localStorage.getItem('supplier');
    },
    routPath(state) {
      return state.routPath || localStorage.getItem('routPath');
    },
    method(state) {
      return state.routPath || localStorage.getItem('method');
    },
    supplierId(state) {
      return state.supplierId || localStorage.getItem('supplierId');
    },
    marketPlaceProductType(state) {
      return state.marketPlaceProductType || localStorage.getItem('marketPlaceProductType');
    },
    transactionAmount(state) {
      return state.transactionAmount || localStorage.getItem('transactionAmount');
    },
    transactionID(state) {
      return state.transactionID || localStorage.getItem('transactionID');
    },
    uploadedDocuments(state) {
      return state.uploadedDocument || [];
    },
    invoiceNumber(state) {
      return state.invoiceNumber || localStorage.getItem('invoiceNumber');
    },
    paymentMethod(state) {
      return state.paymentMethod || localStorage.getItem('paymentMethod');
    }
  };

  export default getters;
